import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconUnchecked = ({ t, className, height, width, fill }) => (
  <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='1' y='1' width='16' height='16' rx='8' stroke={fill} strokeWidth='2' />
  </svg>
)

export default Icon(IconUnchecked)
